// src/Models/Schemas/form-edit-empleado.js
import * as Yup from "yup";

export const FormEditEmpleadoSchema = () =>
  Yup.object().shape({
    numeroEmpleado: Yup.number().required("El número de empleado es requerido"),

    // --- Datos personales ---
    nombre: Yup.string().required("El nombre es requerido").trim(),
    apellidoPaterno: Yup.string().required("El apellido paterno es requerido").trim(),
    apellidoMaterno: Yup.string().required("El apellido materno es requerido").trim(),
    curp: Yup.string()
      .required("El CURP es requerido")
      .length(18, "El CURP debe tener 18 caracteres")
      .trim(),
    rfc: Yup.string().required("El RFC es requerido").trim(),
    fechaNacimiento: Yup.string()
      .required("La fecha de nacimiento es requerida")
      .matches(/^\d{4}-\d{2}-\d{2}$/, "El formato debe ser YYYY-MM-DD"),
    numeroSeguroSocial: Yup.string().required("El número de seguro social es requerido").trim(),
    gradoEstudios: Yup.string().required("El grado de estudios es requerido").trim(),

    // Contacto de emergencia (plano, solo el primero)
    contactoEmergenciaNombre: Yup.string().required("El nombre de contacto es requerido").trim(),
    contactoEmergenciaParentesco: Yup.string().required("El parentesco es requerido").trim(),
    contactoEmergenciaTelefono: Yup.string().required("El teléfono es requerido").trim(),
    contactoEmergenciaTelefonoAlterno: Yup.string().trim(),
    contactoEmergenciaDireccion: Yup.string().trim(),

    // --- Datos bancarios ---
    clabeNomina: Yup.string().required("La CLABE es requerida").trim(),
    bancoNomina: Yup.string().required("El banco es requerido").trim(),
    titularNomina: Yup.string().required("El titular es requerido").trim(),

    clabeAdicional: Yup.string().trim(),
    bancoAdicional: Yup.string().trim(),
    titularAdicional: Yup.string().trim(),

    // --- Datos del puesto ---
    puesto: Yup.string().required("El puesto es requerido").trim(),
    area: Yup.string().required("El área es requerida").trim(),
    fechaIngreso: Yup.string()
      .required("La fecha de ingreso es requerida")
      .matches(/^\d{4}-\d{2}-\d{2}$/, "El formato debe ser YYYY-MM-DD"),

    // Periodo actual
    fechaEgreso: Yup.string()
      .nullable()
      .matches(/^$|^\d{4}-\d{2}-\d{2}$/, "El formato debe ser YYYY-MM-DD"),
    activo: Yup.boolean(),

    // Campos para vacaciones (primer registro plano)
    vacFolio: Yup.string(),
    vacDias: Yup.number(),
    vacFechas: Yup.string(), // Si mandas fechas como string concatenado por comas o similar
    vacAnio: Yup.number(),

    // Puedes agregar más campos planos aquí según tu UI lo requiera
  });
